import React from "react";
import { FormDrawer as SharedFormDrawer, type FormDrawerProps as SharedFormDrawerProps } from "../../../../../shared/frontend/components/FormDrawer";
import { drawerDefaults } from "../app/design-system";
import type { LocalizedText } from "../app/i18n/i18n";
import { useI18n } from "../app/i18n/useI18n";

export interface FormDrawerProps extends Omit<SharedFormDrawerProps, "title" | "submitText" | "cancelText" | "enabledSwitchLabel"> {
  title: LocalizedText; titleNode?: React.ReactNode; submitText?: LocalizedText; cancelText?: LocalizedText;
  enabledSwitchLabel?: LocalizedText | false; saveButtonTextKey?: string; saving?: boolean; showSaveButton?: boolean;
}

/** Translation and compatibility adapter; responsive layout, locking, loading and keyboard handling are shared. */
export function FormDrawer(props: FormDrawerProps) {
  const { text } = useI18n();
  return <SharedFormDrawer {...props} title={props.titleNode ?? text(props.title)}
    submitting={props.submitting ?? props.saving} hideSubmit={props.hideSubmit || props.showSaveButton === false}
    submitText={props.submitText ? text(props.submitText) : props.saveButtonTextKey ? text(props.saveButtonTextKey) : text("Save")}
    cancelText={props.cancelText ? text(props.cancelText) : text("Cancel")}
    closeText={props.closeText ?? text("Close")}
    enabledSwitchLabel={props.enabledSwitchLabel === false ? false : text(props.enabledSwitchLabel ?? "Enabled")}
    width={props.width ?? drawerDefaults.width} loadingLabel={text("Loading…")}
    loadingScreenTopInset={props.loadingScreenTopInset ?? "var(--mu-desktop-overlay-top, var(--critical-issue-banner-height, 0px))"} />;
}
